/**
 * Product operations available for signatories in the Person domain.
 * Shared between ContractType configuration and Person signatory modal.
 *
 * These represent Agrolend product lines (not credit operation modalities).
 */
export const PERSON_PRODUCTS = [
    'CORE',
    'KEEP',
    'CLEAN',
    'FORFAITING',
    'SHIELD',
    'FLOW',
    'Aditamento',
] as const;

export type PersonProduct = typeof PERSON_PRODUCTS[number];
